import { IDenialCategory } from './../../../core/interfaces/deposit.interface';
import { Http, Response } from '@angular/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';
import { constant } from 'app/app.constants';
import { ISummary } from 'app/core/interfaces/summary-interface';
import { IDetailsSummary, IEventBtn, IMovement } from './billed-interface';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BilledService extends ParentService {

  private summaryData = new BehaviorSubject<ISummary>(undefined);
  summaryData$ = this.summaryData.asObservable();

  private dataFilter = new BehaviorSubject<IDetailsSummary>(null);
  dataFilter$ = this.dataFilter.asObservable();

  private dataMovement = new BehaviorSubject<IMovement>(null);
  dataMovement$ = this.dataMovement.asObservable();

  private dataDenials = new BehaviorSubject<any>(null);
  dataDenials$ = this.dataDenials.asObservable();

  private denialCategories = new BehaviorSubject<IDenialCategory[]>(null);
  denialCategories$ = this.denialCategories.asObservable();

  private closeModal = new BehaviorSubject<boolean>(false);
  closeModal$ = this.closeModal.asObservable();

  private openModalAssignCategory = new BehaviorSubject<boolean>(false);
  openModalAssignCategory$ = this.openModalAssignCategory.asObservable();

  private tripIds = new BehaviorSubject<number[]>(null);
  tripIds$ = this.tripIds.asObservable();

  @Output() scheduelEvent: EventEmitter<IEventBtn> = new EventEmitter();
  @Output() exporToExcel: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: Http) {
    super();
  }

  getSummaryData(data): void {
    this.summaryData.next(data);
  }

  sendDataFilter(data) {
    this.dataFilter.next(data);
  }

  getDataMovement(data) {
    this.dataMovement.next(data);
  }

  getDataDenials(data) {
    this.dataDenials.next(data);
  }

  getPayorsType() {
    return this.http.get(`${constant.URL_PAYOR_TYPE}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getPayorsAll() {
    return this.http.get(`${constant.URL_PAYOR_LIST}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getTripsToExport(body) {
    return this.http.post(constant.URL_EXPORT_TRIPS, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getBillingStatus() {
    return this.http
      .get(`${constant.URL_BILLING_STATUS}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getSummary(body) {
    return this.http.post(constant.URL_BILLING_SUMMARY, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getRoleActionByModule(id) {
    return this.http.get(`${constant.URL_GETMODULEACTION}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getMassMovement(body) {
    return this.http.post(constant.URL_MASS_MOVEMENT, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getBillingSchedule() {
    return this.http.get(constant.URL_BILLING_SCHEDULE_LIST, this.getHeader())
      .map((Response) => Response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getBillingStatusDenial(body) {
    return this.http.post(constant.URL_BILLING_STATUS_DENIAL, body, this.headerPost())
    .map(res => res.json())
    .catch(error => Observable.throw(error.json()));
  }

   getDenialsCategory() {
    return this.http
      .get(constant.URL_ADD_DENIAL_CATEGORIES_CODE, this.getHeader())
      .map((Response) => Response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  categorizeDenialTrip(data: { tripId: number; denialCategoryId: number; }) {
    return this.http
      .post(
        `${constant.URL_ADD_DENIAL_CATEGORIZE_DENIAL_TRIP}`,
        data,
        this.headerPost()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


   autoAssignDenialCategory(tripIds: number[]) {
    return this.http
      .post(
        constant.URL_ADD_DENIAL_ASSIGN_MASSIVE_CATEGORY_TRIP,
        tripIds,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setDenialCategories(data: IDenialCategory[]) {
    this.denialCategories.next(data);
  }

  triggerCloseModal(value: boolean) {
    this.closeModal.next(value);
  }

  triggerOpenModalAssignCategory(value: boolean) {
    this.openModalAssignCategory.next(value);
  }

  setTripIds(data: number[]) {
    this.tripIds.next(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/billed.service.ts